import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse, HttpResponse } from "@angular/common/http";
import { from, Observable, throwError } from "rxjs";
import { catchError, map } from "rxjs/operators";
import { ErrorHttpParams } from "./errror.httpparams";
import { SharedActions } from "../shared.actions";
import { UserFeedbackService } from "../../services/user-feedback.service";
import { TranslateService } from "@ngx-translate/core";
import { formatErrorMessage, UNEXPECTED_SERVER_ERROR_KEY } from "./error-message-formatter";
import { OptimisticPlanningService } from "../../optimistic-planning/optimistic-planning.service";

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {

  constructor(
    public readonly sharedActions: SharedActions,
    private readonly userFeedbackService: UserFeedbackService,
    private readonly optimisticPlanning: OptimisticPlanningService,
    private readonly translate: TranslateService
  ) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.sharedActions.httpRequestPending(true);
    return next.handle(request)
      .pipe(catchError(error => from(this.handleError(error, request))))
      .pipe(map<HttpEvent<any>, any>((evt: HttpEvent<any>) => {
        if (evt instanceof HttpResponse) {
          this.sharedActions.httpRequestPending(false);
        }
        return evt;
      })) as Observable<HttpEvent<any>>;
  }

  async handleError(error: HttpErrorResponse, request: HttpRequest<any>) {
    this.sharedActions.setLoading(true);
    this.sharedActions.setLoading(false);
    this.sharedActions.httpRequestPending(false);

    if (this._shouldIgnoreError(request)) {
      return throwError(error).toPromise();
    }

    let message = await formatErrorMessage(error, this.translate.instant(UNEXPECTED_SERVER_ERROR_KEY));
    if (message.length > 200) {
      message = message.substring(0, 200) + "...";
    }
    this.userFeedbackService.showErrorMessageWithoutTranslating(message, undefined, { enableHtml: false });
    return throwError(error).toPromise();
  }

  _shouldIgnoreError(request: HttpRequest<any>) {
    if (request.params instanceof ErrorHttpParams && request.params.ignoreException) return true;
    // In optimistic mode (either domain), the optimistic UI handles errors — skip global toast
    if (this.optimisticPlanning.anyEnabled) return true;
    return false;
    }
  }
